import type { TFunction } from "i18next";

/**
 * Maps known Supabase auth error messages (English) to translated strings.
 * Falls back to the original message if nothing matches.
 */
export function mapAuthError(message: string | undefined | null, t: TFunction): string {
  const msg = (message ?? "").toLowerCase().trim();
  if (!msg) return t("auth:errors.generic");

  if (/known to be weak|weak[_ ]password|password.*(weak|easy to guess)/i.test(msg)) {
    return t("auth:errors.weakPassword");
  }
  if (/invalid login credentials|invalid_credentials|invalid email or password/i.test(msg)) {
    return t("auth:errors.invalidCredentials");
  }
  if (/user already registered|already.*registered|already exists/i.test(msg)) {
    return t("auth:errors.userAlreadyRegistered");
  }
  if (/email not confirmed|email_not_confirmed|confirm.*email/i.test(msg)) {
    return t("auth:errors.emailNotConfirmed");
  }
  if (/rate limit|for security purposes|too many requests|over_email_send_rate_limit/i.test(msg)) {
    return t("auth:errors.rateLimit");
  }
  if (/same.*password|new password should be different/i.test(msg)) {
    return t("auth:errors.samePassword");
  }
  if (/invalid.*email|email.*invalid|unable to validate email/i.test(msg)) {
    return t("auth:errors.invalidEmail");
  }
  if (/password.*at least|password.*should be at least|password.*minimum/i.test(msg)) {
    return t("auth:errors.passwordTooShort");
  }

  return message ?? t("auth:errors.generic");
}

export function isEmailNotConfirmedError(message: string | undefined | null): boolean {
  const msg = (message ?? "").toLowerCase();
  return /email not confirmed|email_not_confirmed/i.test(msg);
}
